module.exports = __webpack_public_path__ + "static/media/elena_karanfilovska.7d5c9e03.jpg";